export default "__VITE_ASSET__b00922fc__"